
import { Component, Vue, Prop, PropSync } from "vue-property-decorator";
// import { formatImageSrc } from "@/utils";
import { formatUpyunUrl } from "@/utils";
export default class CertExample extends Vue {
  @Prop({ required: false, default: false }) show: any;
  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/12b39076fe43004f811ae40e570a8e92.png";
  pic2 = "/img/9a7219c484a1953ef47c1907d05ae602.png";

  id = "";

  closeDialog() {
    this.$emit("close");
  }
}
